<template>
    <div ref="container" class="overflow-auto" :class="{'pr-2' : addPadding}">
        <slot></slot>
    </div>
</template>

<script>
export default {
    data() {
        return {
            addPadding: false,
        }
    },
    methods: {
        adjustPadding() {
            let app = this;
            this.$nextTick(() => {
                const container = app.$refs.container;
                if (!container) return;
                app.addPadding = container.scrollHeight > container.clientHeight;
            });
        },
    },
    mounted() {
        let app = this;
        app.adjustPadding();
        window.addEventListener('resize', this.adjustPadding);

        const targetNode = this.$refs.container;

        const callback = function(mutationsList, observer) {
            app.adjustPadding();
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, { attributes: true, childList: true, subtree: true });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.adjustPadding);
    },
}
</script>
